import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { solutions } from "../../mock";

export const Solutions = () => (
  <section id="solutions" data-testid="solutions-section" className="py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-violet-400 mb-4">Solution Domains</p>
      <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-white max-w-2xl">
        Seven domains. One defense-first standard.
      </h2>
      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
        {solutions.map((s) => {
          const Icon = s.icon;
          return (
            <Link key={s.title} to={`/solutions/${s.slug}`}
              data-testid={`solution-card-${s.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="bg-[#0B1035] p-8 lg:p-10 hover:bg-white/[0.03] transition-colors group block">
              <Icon className="w-8 h-8 text-cyan-400 mb-6" />
              <h4 className="font-heading text-lg font-medium text-white group-hover:text-cyan-300 transition-colors">{s.title}</h4>
              <p className="mt-3 text-sm text-slate-400 leading-relaxed">{s.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm text-cyan-400 opacity-0 group-hover:opacity-100 transition-opacity">
                View capability map <ArrowRight className="w-4 h-4" />
              </span>
            </Link>
          );
        })}
        <div className="bg-[#0B1035] p-8 lg:p-10 flex flex-col justify-center">
          <p className="font-heading text-lg font-medium text-cyan-400">Not sure where to start?</p>
          <Link to="/intake" data-testid="solutions-cta" className="mt-3 text-sm text-white underline underline-offset-4 hover:text-cyan-300 transition-colors">
            Request a free assessment →
          </Link>
        </div>
      </div>
    </div>
  </section>
);
